var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLight6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "#EAFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7913 34.9994V55.8327H18.8538C17.1304 55.8327 15.7288 54.4311 15.7288 52.7077V34.8941C16.0653 34.9629 16.4137 34.9994 16.7705 34.9994H29.7913ZM31.8747 34.9994V55.8327H38.1247V34.9994H31.8747ZM53.2288 34.9994H40.208V55.8327H51.1455C52.8689 55.8327 54.2705 54.4311 54.2705 52.7077V34.8941C53.934 34.9629 53.5856 34.9994 53.2288 34.9994ZM56.3538 25.6243V29.791C56.3538 31.5145 54.9523 32.916 53.2288 32.916H16.7705C15.0471 32.916 13.6455 31.5145 13.6455 29.791V25.6243C13.6455 23.9009 15.0471 22.4993 16.7705 22.4993H26.6762C26.0195 21.6275 25.6247 20.5473 25.6247 19.3743C25.6247 16.5025 27.9611 14.166 30.833 14.166C32.5377 14.166 34.0491 14.9931 34.9997 16.2629C35.9507 14.9931 37.4616 14.166 39.1663 14.166C42.0382 14.166 44.3747 16.5025 44.3747 19.3743C44.3747 20.5473 43.9799 21.6275 43.3231 22.4993H53.2288C54.9523 22.4993 56.3538 23.9009 56.3538 25.6243ZM36.0413 19.3743V22.4993H39.1663C40.8898 22.4993 42.2913 21.0978 42.2913 19.3743C42.2913 17.6509 40.8898 16.2493 39.1663 16.2493C37.4429 16.2493 36.0413 17.6509 36.0413 19.3743ZM30.833 22.4993H33.958V19.3743C33.958 17.6509 32.5564 16.2493 30.833 16.2493C29.1096 16.2493 27.708 17.6509 27.708 19.3743C27.708 21.0978 29.1096 22.4993 30.833 22.4993Z",
    fill: "#009999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight6);
export default __webpack_public_path__ + "static/media/Icon-light-6.1e293b741411dc76210f0c46dc49e39b.svg";
export { ForwardRef as ReactComponent };